import { URL_MAIN_PAGE } from '@hive/platform-url-schema'
import { generatePath, Navigate } from 'react-router'

export function CatalogRedirect () {
  const newPath = generatePath(URL_MAIN_PAGE)
  return <Navigate to={newPath} replace />
}
